import { useContext } from "react";

import { OpenSearchProductsContext } from "../context/OpenSearchProductsContext";

const useOpenSearchProducts = () => {
    const ctx = useContext(OpenSearchProductsContext);
    if (!ctx) {
        throw new Error(
            "useOpenSearchProducts must be used within OpenSearchProductsProvider",
        );
    }
    return ctx;
};

export { useOpenSearchProducts };
